import { GetStaticProps, NextPage } from 'next'
import { AppProps } from 'next/app'
import MaxWidth from '../../components/layout/MaxWidth/MaxWidth'

import { initializeApollo } from '../../lib/apolloClient'
import globalCache from '../../lib/globalCache'
import LookBookList from '../../components/lookbook/LookBookList/LookBookList'
import LookBookTitle from '../../components/lookbook/LookBookTitle/LookBookTitle'
import { LOOKBOOK_ITEMS } from '../../queries/lookbook'
import {
  lookbook_itemsVariables,
  lookbook_items,
} from '../../__generated__/lookbook_items'

import { SortOrder } from '../../__generated__/globalTypes'
import LookbookProvider from '../../contexts/lookbookProvider'
import { HeaderColors } from '../../components/types'
import { createPageSeo, getPageSeo } from '../../lib/createPageSeo'

const LookBook: NextPage<AppProps> = () => {
  return (
    <main>
      <LookbookProvider>
        <MaxWidth mobileWide>
          <LookBookTitle />
          <LookBookList />
        </MaxWidth>
      </LookbookProvider>
    </main>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const apolloClient = initializeApollo()
  await globalCache(apolloClient)

  let seo

  const [seoData] = await Promise.all([
    getPageSeo(apolloClient, 'lookbook-main'),
    apolloClient.query<lookbook_items, lookbook_itemsVariables>({
      query: LOOKBOOK_ITEMS,
      variables: {
        where: {
          iblock: {
            code: {
              equals: 'lookbook',
            },
          },
          active: {
            equals: true,
          },
        },
        first: 4,
        order: { sort: SortOrder.asc },
      },
    }),
  ])

  if (seoData?.data?.element) {
    seo = createPageSeo(seoData.data)
  }

  return {
    props: {
      __APOLLO_STATE__: apolloClient.cache.extract(),
      headerInitColor: HeaderColors.white,
      seo,
    },
    revalidate: 60,
  }
}

export default LookBook
